import type { ReactNode } from 'react'

import type { EVENTS, PUBLICATION_TRACKING_SOURCE, TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'

import type { TMergePublicationTypes } from '../../../models/publication.types'
import { usePublicationHandlers } from '../PublicationCard/usePublicationHandlers'
import type { TPublicationToShare } from '../PublicationShareModal'
import type { TPublicationItemBaseProps } from './PublicationItemBase'
import { PublicationItemBase } from './PublicationItemBase'

export type TPublicationItemProps = Omit<
  TPublicationItemBaseProps,
  'onCardPress' | 'onCommentPress' | 'onSharePress' | 'showThread' | 'publication'
> & {
  publication: TMergePublicationTypes<[TPublicationItemBaseProps['publication'], TPublicationToShare]>
} & {
  trackingSource: TRACKING_SOURCE
  publicationTrackingSource: PUBLICATION_TRACKING_SOURCE
  cardClickEvent?: EVENTS
}

export const PublicationItem = ({
  cardClickEvent,
  publication,
  publicationTrackingSource,
  trackingSource,
  ...otherProps
}: TPublicationItemProps): ReactNode => {
  const handlers = usePublicationHandlers({
    publication,
    trackingSource,
    publicationTrackingSource,
    cardClickEvent,
  })

  return <PublicationItemBase publication={publication} {...handlers} {...otherProps} />
}
